// src/pages/HomeView/hooks/useLicense.ts
import { useState, useEffect } from 'react';

interface LicenseData {
  isValid: boolean;
  isSigned: boolean;
  isExpired: boolean;
  errorMessage?: string;
}

export const useLicense = () =>
{
  const [isLoading, setIsLoading] = useState(true);
  const [isLicenseValid, setIsLicenseValid] = useState(true);
  const [licenseError, setLicenseError] = useState<string | null>(null);

  useEffect(() =>
  {
    checkLicense();
  }, []);

  const checkLicense = async () =>
  {
    try
    {
      setIsLoading(true);

      // TODO: Implementar llamada al servicio Profile.getLicense()
      // Por ahora, asumimos que la licencia es válida
      const licenseData: LicenseData = {
        isValid: true,
        isSigned: true,
        isExpired: false,
      };

      if (!licenseData.isSigned)
      {
        setIsLicenseValid(false);
        setLicenseError(licenseData.errorMessage || 'License is not signed');
      }
      else if (licenseData.isExpired)
      {
        setIsLicenseValid(false);
        setLicenseError(
          licenseData.errorMessage ||
            'Your license has expired. Please contact your Corgee administrator.',
        );
      }
      else
      {
        setIsLicenseValid(true);
        setLicenseError(null);
      }
    }
    catch (error)
    {
      console.error('Error checking license:', error);
      // En caso de error, permitir el acceso (comportamiento similar al legacy)
      setIsLicenseValid(true);
      setLicenseError(null);
    }
    finally
    {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isLicenseValid,
    licenseError,
  };
};
